import { render, staticRenderFns } from "./mpquery.vue?vue&type=template&id=1e49182d&"
import script from "./mpquery.vue?vue&type=script&lang=js&"
export * from "./mpquery.vue?vue&type=script&lang=js&"
import style0 from "./mpquery.vue?vue&type=style&index=0&id=1e49182d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports